import { Extension } from '@tiptap/core';

// A line the writer left themselves rather than part of the work: "where she
// realizes he lied", "check this against the transcript". A storyboard's card
// notes arrive in a new draft as these, and the writer can mark or unmark any
// paragraph as one.
//
// Marked as BOTH a class (which the PDF/DOCX/RTF exporters select on, having
// no attribute selectors) and a data attribute (what parseHTML trusts when a
// saved document is loaded), the same way screenplay elements are. The server
// strips these paragraphs from every export unless asked for the working
// draft, so a note to self cannot reach a finished manuscript.
//
// Without this extension the attribute would not survive a round trip:
// ProseMirror drops markup it has no schema for, so opening a generated draft
// and letting autosave run would quietly turn the scaffolding into ordinary
// prose — and then export it.

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    writerNote: {
      toggleWriterNote: () => ReturnType;
    };
  }
}

const NOTE_TYPES = ['paragraph', 'heading'];

export const WriterNote = Extension.create({
  name: 'writerNote',

  addGlobalAttributes() {
    return [
      {
        types: NOTE_TYPES,
        attributes: {
          ybNote: {
            default: false,
            parseHTML: (element) => element.hasAttribute('data-yb-note'),
            renderHTML: (attributes) => {
              if (!attributes.ybNote) return {};
              return { 'data-yb-note': '1', class: 'yb-note' };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      toggleWriterNote:
        () =>
        ({ editor, commands }) => {
          const type = NOTE_TYPES.find((name) => editor.isActive(name)) || 'paragraph';
          const isNote = Boolean(editor.getAttributes(type).ybNote);
          return commands.updateAttributes(type, { ybNote: !isNote });
        },
    };
  },
});
